// extracted by mini-css-extract-plugin
export default {"radio":"style_radio__fz4tk"};